import { default as team } from './client-team'
import getConfig from 'next/config'
import { buildBaseUrl } from '../utils';

const { publicRuntimeConfig: { genericRESTUrl } } = getConfig();

const teamClient = team({
  host: `${genericRESTUrl}/v1/team`,
  requestInterceptor: {
    fulfilled: (config: any) => {
      if (window.todesktop) {
        config.headers['Source'] = 'desktop';
      }

      config.baseURL = buildBaseUrl(window.location.href, config.baseURL!);
      return config;
    },
    rejected: (error: any) => {
      return error;
    },
  },
})

export default teamClient;
